export class DeepLinkProviderMissingError extends Error {
    constructor(message = 'DeepLink hooks must be used within DeepLinkProvider.') {
        super(message);
        this.name = 'DeepLinkProviderMissingError';
    }
}
